import template from './labelsSelect.template.html';

export default {
  template,
  bindings: {
    labels: '<',
    selectedLabels: '<',
    data: '<',
    isDisabled: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $mdMedia) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.chosenLabels = [];

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.labels = ctrl.labels || [];
        ctrl.selectedLabels = ctrl.selectedLabels || [];
        ctrl.data = ctrl.data || {};
        ctrl.isDisabled = ctrl.isDisabled || false;
        ctrl.chosenLabels = _.filter(
          ctrl.labels,
          (label) => ctrl.selectedLabels.indexOf(label.id) > -1
        );
        ctrl.chosenLabels.sort(
          (a, b) => ctrl.selectedLabels.indexOf(a.id) - ctrl.selectedLabels.indexOf(b.id)
        );
      };

      ctrl.transformChip = (chip) => (angular.isObject(chip) ? chip : { name: chip });

      ctrl.removeChip = () => {
        const selectedLabelsId = _.map(ctrl.chosenLabels, 'id');
        ctrl.onFinished({ selectedLabels: selectedLabelsId, data: ctrl.data });
      };

      ctrl.choseLabel = (item) => {
        ctrl.addLabel(item);
      };

      ctrl.searchLabels = (query) =>
        query ? ctrl.labels.filter(ctrl.createFilterFor(query)) : [];

      ctrl.createFilterFor = (query) =>
        function filterFn(label) {
          return label.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
        };

      ctrl.addLabel = (label) => {
        if (!label || !label.id) {
          return;
        }
        ctrl.chosenLabels.push(label);
        const selectedLabelsId = _.map(ctrl.chosenLabels, 'id');
        ctrl.onFinished({ selectedLabels: selectedLabelsId, data: ctrl.data });
      };

      ctrl.isLabelSelected = (idLabel) => {
        const idx = _.findIndex(ctrl.chosenLabels, (l) => l.id === idLabel);
        return idx > -1;
      };

      ctrl.areAllLabelsSelected = () => ctrl.labels.length === ctrl.chosenLabels.length;

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
